import React from 'react';
import { Outlet } from 'react-router-dom';

export const GrilleTarifaireRoot: React.FunctionComponent = function () {
    return <Outlet />;
};

export default GrilleTarifaireRoot;
